import { render, staticRenderFns } from "./multilang-array-input.vue?vue&type=template&id=16f5a0d3&"
import script from "./multilang-array-input.vue?vue&type=script&lang=ts&"
export * from "./multilang-array-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports